import { render, staticRenderFns } from "./maintainance.vue?vue&type=template&id=b4c44a56&scoped=true&"
import script from "./maintainance.vue?vue&type=script&lang=js&"
export * from "./maintainance.vue?vue&type=script&lang=js&"
import style0 from "./maintainance.vue?vue&type=style&index=0&id=b4c44a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c44a56",
  null
  
)

export default component.exports